export enum TRANSLATION_KEYS {
  ACCOUNT = 'account',
  AUTOCANADA = 'autocanada',
  COMMON = 'common',
  CPO = 'cpo',
  FAVOURITES = 'favourites',
  FEEDBACK = 'feedback',
  FORGOT_PASSWORD = 'forgot_password',
  GLOBAL_FOOTER = 'global_footer',
  GLOBAL_HEADER = 'global_header',
  HOME = 'home',
  LANDING_PAGE = 'landing_page',
  LISTING = 'listing',
  LOGIN = 'login',
  MOBILE_LINK = 'mobile_link',
  NOT_FOUND = '404',
  PAID_FEATURES = 'paidFeatures',
  PAYMENT_ESTIMATOR = 'payment_estimator',
  PROFILE = 'profile',
  R2S = 'r2s',
  REGISTER = 'register',
  REQUEST_VIEWING = 'request_viewing',
  RESET_PASSWORD = 'reset_password',
  ROUTES = 'routes',
  SRP = 'srp',
  TRADE_IN = 'trade_in',
  USER_VERIFICATION = 'user_verification',
  VIP = 'vip',
}
